// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tfce","option":"styles_option__38edH","active":"styles_active__2FLku"};